import React from 'react';
import { Dashboard } from '../pages/Dashboard';
import { Courses } from '../pages/Courses/Courses';
import { Header } from "../container/Header";
import { Team } from "../pages/Team/Team";
import { ProfileUser } from "../pages/ProfileUser/ProfileUser";
import LearnerProfile from "../pages/LearnerProfile/LearnerProfile";

const routes = [
  {
    component: <><Header /><Dashboard /></>,
    exact: true,
    path: '/dashboard'
  },
  {
    component: <><Header /><Courses /></>,
    exact: true,
    path: '/courses'
  },
  {
    component: <><Header /><Courses /></> ,
    path: '/courses/overview/:id'
  },
  {
    component: <><Header/><Courses/></>,
    path: '/courses/catalogue-overview/:id'
  },
  {
    component: <><Header/><Team /></>,
    path: '/team',
  },
  {
    component: <><Header/><ProfileUser /></>,
    path: '/profile'
  },
  {
    component: <><Header/><LearnerProfile /></>,
    path: '/team/learner-profile/:learner_id'
  },

];
export default routes;
